module.exports = __webpack_public_path__ + "assets/img/LIFESTYLE FOR BROCHURE.637ba109.png";